import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDirectionDown(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5.293 8.293a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414L12 13.586 6.707 8.293a1 1 0 0 0-1.414 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
